<div class="popup mat-elevation-z8">
  <div class="popup__title-wrapper">
    <span>{{ 'CORE.SERVICES.NAVIGATION.INDICATION.POPUP.TEXT' | translate }}</span>
    <a (click)="closePopup()"><mat-icon inline class="popup__close-icon">close</mat-icon></a>
  </div>

  <a
    href="https://bit.ly/3PuA39s"
    target="_blank"
    mat-stroked-button
    color="primary"
    class="popup__button"
    (click)="closePopup()"
  >
    {{ 'CORE.SERVICES.NAVIGATION.INDICATION.POPUP.BUTTON' | translate }}
    <mat-icon class="nav-link-icon">handshake</mat-icon>
  </a>
</div>
